import { LitElement, html, css, nothing } from "lit";
import { property, customElement } from "lit/decorators.js";
import { SvgIcons } from "../voyage-svg-icons/src/voyage-svg-icons";

import "@maersk-global/mds-components-core/mc-modal";
import { FleetAlarm } from "../../src/models/types/voy-fleet-alarm-model.types";
import {
  formatTimeDifference,
  getAuditLogMessage,
  getNotificationMessage,
} from "../acitivity-log/helper";
import { AuditLog } from "../../src/services/types/fleet-weather-routing-notification.types";

@customElement("voy-feature-view-notes-popup")
export class VoyFeatureViewNotes extends LitElement {
  @property({ type: Boolean, reflect: true }) shown: boolean = true;
  @property({ type: Boolean, reflect: true }) showCloseIcon: boolean = true;
  @property({ type: Object }) alarm: FleetAlarm | null = null;
  @property({ type: Object }) auditLog: AuditLog| null = null;

  constructor() {
    super(); 
  }
  static get styles() {
    return [
      css`
        :host {
          display: block;
          font-family: Arial, sans-serif;
        }
        .modal {
          display: block;
          z-index: 1;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          overflow: auto;
        }
        .close {
          color: #aaa;
          font-size: 28px;
          font-weight: bold;
          cursor: pointer;
        }
        .close:hover,
        .close:focus {
          color: #000;
          text-decoration: none;
          cursor: pointer;
        }
        .note-item {
          display: flex;
          align-items: center;
          margin-bottom: 16px;
        }
        .note-avatar {
          order: 1;
          margin-right: 10px;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background-color: #e95439;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: #fff;
          margin-right: 10px;
        }
        .note-header {
          display: flex;
          align-items: center;
          gap: 20px;
          margin-top: 12px;
        }
        .note-author {
          order: 2;
          margin-right: auto;
          margin-bottom: 5px;
        }
        .note-time {
          order: 3;
          margin-left: auto;
          font-size: 12px;
          color: #999;
        }
        .note-section {
          border-bottom: 1px solid #e5e5e5;
          margin-bottom: 9px;
          padding-bottom: 10px;
        }
      `,
    ];
  }

  render() {
    if (!this.alarm && !this.auditLog) return nothing;
    return html`${this._renderFeedbacktModal()}`;
  }
  private _renderFeedbacktModal() {
    const notificationMessage = this.alarm ? getNotificationMessage(this.alarm) : this.auditLog ? getAuditLogMessage(this.auditLog, true) : '';
    return html`<mc-modal
      heading=${notificationMessage}
      ?open=${this.shown}
      dimension="medium"
      width="650px"
      height="400px"
      backdropcloseactiondisabled
      escapecloseactiondisabled
      entercloseactiondisabled
      ?hiddenclose=${!this.showCloseIcon}
      @closing=${() => {
        this.dispatchEvent(new Event("close"));
      }}
    >
      ${this._renderModalContent()}
    </mc-modal> `;
  }

  private _renderModalContent() {
    return html`
    <div class="modal">
          <div class="notes">
            <h4>All Notes</h4>
            ${this.alarm ? this._renderAlarmNotes() : this._renderAuditLogNotes()}
          </div>
        </div>
      </div>
        `;
  }

  private _renderAlarmNotes() {
    return this.alarm?.alarmLogs
      .filter(
        (alarmLog) => alarmLog.note !== "" && alarmLog.userId !== "system"
      )
      .map(
        (log) => html`
          <div class="note-section">
            <div class="note-item">
              <div class="note-avatar">
                ${log.userData
                  ?.displayName!.split(" ")
                  .map((n) => n[0])
                  .join("")}
              </div>
              <div class="note-author">${log.userData?.displayName}</div>
              <div class="note-time">
                ${formatTimeDifference(log.createdAt)}
              </div>
            </div>
            <div class="note-text">${log.note}</div>
          </div>
        `
      );
  }

  private _renderAuditLogNotes() {
    const notes = this.auditLog?.notes
      ? JSON.parse(this.auditLog.notes)
      : [];
  
    if (!notes.length) return nothing;
  
    return notes.map(
      (log: any) => html`
        <div class="note-section">
          <div class="note-item">
            <div class="note-avatar">
              ${log.user.split(" ")
                .map((n: string) => n[0])
                .join("")}
            </div>
            <div class="note-author">${log.user}</div>
            <div class="note-time">${formatTimeDifference(log.createdAt)}</div>
          </div>
          <div class="note-text">${log.comment}</div>
        </div>
      `
    );
  }
  
}
